import { Link } from "react-router-dom";
import { featuredNews } from "@/mocks/sportsData";

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热点聚焦
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              精选热门赛事与深度报道
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {featuredNews.map((item, index) => (
            <Link
              key={item.id}
              to={`/category/${item.category}`}
              className={`relative rounded-2xl overflow-hidden cursor-pointer group ${
                index === 0 ? "lg:row-span-2 lg:col-span-2 h-[280px] md:h-[420px]" : "h-[280px] md:h-[200px]"
              }`}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 bg-accent-500 text-white text-xs font-semibold rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-xs text-white/70">{item.categoryName}</span>
                </div>
                <h3 className={`font-semibold text-white group-hover:text-primary-300 transition-colors line-clamp-2 leading-snug ${index === 0 ? "text-lg md:text-xl" : "text-base"}`}>
                  {item.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}